import {SemanticSearchSurfacePhase} from "../state/semantic_search_modal_slice";

export type AmplitudeSemanticSearchModalSize = "half" | "full";

export const getSemanticSearchModalSize = (phase: SemanticSearchSurfacePhase): AmplitudeSemanticSearchModalSize | null => {
    if (phase === "halfSheet") {
        return "half";
    }

    if (phase === "fullscreen") {
        return "full";
    }

    return null;
};
import {SemanticSearchSurfacePhase} from "../state/semantic_search_modal_slice";

export type AmplitudeSemanticSearchModalSize = "half" | "full";

export const getSemanticSearchModalSize = (phase: SemanticSearchSurfacePhase): AmplitudeSemanticSearchModalSize | null => {
    if (phase === "halfSheet") {
        return "half";
    }

    if (phase === "fullscreen") {
        return "full";
    }

    return null;
};
